import React, { FC } from 'react';
import { RecommendMens } from '@domain/constant/searchMenuType';
import NumberUtil from '@utils/number/util';
import classnames from 'classnames/bind';
import styles from './searchModal.module.scss';
const cx = classnames.bind(styles);

const RecommendMenuList: FC = () => {
  const randomIndexList = NumberUtil.getRandomIntInclusiveByCount(0, RecommendMens.length - 1, 2);

  const recommendMenuListEl = randomIndexList.map((idx) => {
    const menu = RecommendMens[idx];

    return (
      <a key={idx} href={menu.url} className={cx('keyword', 'option')} target="_blank" rel="noreferrer">
        {menu.title}
      </a>
    );
  });

  return <div className={cx('optionWrap')}>{recommendMenuListEl}</div>;
};

export default RecommendMenuList;
